class Inquiry {
	constructor({
		id = '',
		name = '',
		email = '',
		categ = '',
		message = '',
		createdAt = '',
		receivedAt = '',
		responsedAt = '',
		complitedAt = '',
	} = {}) {
		this.id = id === null ? '' : id
		this.name = name === null ? '' : name
		this.email = email === null ? '' : email
		this.categ = categ === null ? '' : categ
		this.message = message === null ? '' : message
		this.createdAt = createdAt === null ? '' : createdAt
		this.receivedAt = receivedAt === null ? '' : receivedAt
		this.responsedAt = responsedAt === null ? '' : responsedAt
		this.complitedAt = complitedAt === null ? '' : complitedAt
	}
	id: string
	name: string
	email: string
	categ: string
	message: string
	createdAt: string
	receivedAt: string
	responsedAt: string
	complitedAt: string
}

export { Inquiry }
